import { render, staticRenderFns } from "./TimelinesTab.vue?vue&type=template&id=5b2139f4&scoped=true&"
import script from "./TimelinesTab.vue?vue&type=script&lang=ts&"
export * from "./TimelinesTab.vue?vue&type=script&lang=ts&"
import style0 from "./TimelinesTab.vue?vue&type=style&index=0&id=5b2139f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2139f4",
  null
  
)

export default component.exports